var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.get_interview_loading)?[_c('InterviewLoading')]:[_c('candidate-interview-wrapper')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }